<template>
    <div class="inline-block">
        <confirm-modal
            :request-method="requestMethod"
            :action-url="actionUrl"
            :redirect-url="redirectUrl"
            :modal-button-text="buttonText"
            :confirm-text="confirmText"
        >
            <button class="btn btn-md is-ghost is-danger">
                {{ buttonText }}
            </button>
        </confirm-modal>
    </div>
</template>

<script>
    export default {
        props: {
            actionUrl: {
                required: true,
                type: String,
            },
            redirectUrl: {
                required: false,
                type: String,
                default: null,
            },
            buttonText: {
                required: false,
                type: String,
                default: 'Radera',
            },
            confirmText: {
                required: false,
                type: String,
                default: 'Är du säker?',
            },
            requestMethod: {
                type: String,
                default: 'delete',
            },
        },
    };
</script>
